import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const environment =
  (import.meta.env.VITE_SENTRY_ENV as string | undefined) ??
  (import.meta.env.PROD ? "production" : "development");
const release = import.meta.env.VITE_SENTRY_RELEASE as string | undefined;

export function initSentry() {
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
    beforeSend(event, hint) {
      if (event.request?.headers) {
        delete event.request.headers["Authorization"];
        delete event.request.headers["Cookie"];
      }
      // Suppress stale-chunk errors after deploys — expected noise.
      const msg =
        (hint?.originalException as Error | undefined)?.message ??
        event.exception?.values?.[0]?.value ??
        "";
      if (
        /Failed to fetch dynamically imported module/i.test(msg) ||
        /Importing a module script failed/i.test(msg) ||
        /error loading dynamically imported module/i.test(msg) ||
        /Lazy module missing default export/i.test(msg) ||
        /Cannot read propert(y|ies) of undefined \(reading 'default'\)/i.test(msg)
      ) {
        return null;
      }
      return event;
    },
  });
}

export function setSentryUser(user: { id: number; email: string } | null) {
  if (!dsn) return;
  if (user) {
    Sentry.setUser({ id: String(user.id), email: user.email });
  } else {
    Sentry.setUser(null);
  }
}

export { Sentry };
